import { useForm } from '@mantine/form';
import { useTranslation } from 'react-i18next';

export const useRequestPasswordResetForm = () => {
  const { t } = useTranslation();

  const form = useForm({
    initialValues: {
      email: '',
    },
    validate: {
      email: (value: string) =>
        /^\S+@\S+$/.test(value) ? null : t('forms.invalidEmail', 'Mail invalide'),
    },
  });

  return { form };
};
